/**
 * Shared TanStack Query client. Disables refetch-on-focus by default since
 * most of our data is user-initiated (click → mutate → invalidate).
 */
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5_000,
    },
  },
});
